export default __webpack_public_path__ + "static/media/icon-growth3x.4a00afd1.png";